import { CustomerAcquisitionLimits } from '@src/containers/Dealer/CustomerNetAcquisition/CustomerAcquisitionLimits';
import type { CustomerAcquisitionLimitsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAcquisitionLimitsPanel({
  api,
  params,
}: LayoutPanelProps<CustomerAcquisitionLimitsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-acquisition-limits-panel"
    >
      <CustomerAcquisitionLimits />
    </EntityAdminPanelShell>
  );
}
